import React, { useCallback, useRef, useState, useEffect } from "react";
import {
  makeStyles,
  Grid,
  Typography,
  Button,
  Hidden,
  Paper,
  GridList,
} from "@material-ui/core/";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InforWindow,
  InfoWindow,
  InfoBox,
} from "@react-google-maps/api";
import StarIcon from "@material-ui/icons/Star";
import ScrollDownAppBar from "../../Components/ScrollDownAppBar/ScrollDownAppBar";
import BottomPart from "../../Components/BottomPart/BottomPart";
import ExtendCard from "../../Components/ExtendCard/ExtendCard";
import RoomData from "../../Components/ExtendCard/RoomData";
import RoomData2 from "../../Components/ExtendCard/RoomData2";
import Pagination from "../../Components/Pagination/Pagination";
import PopUpCard from "../../Components/PopUpCard/PopUpCard";
import InputInfor from "../../Components/InputInfor/InputInfor";
import WebAppBar from "../../Components/WebAppBar/WebAppBar";
import MapIcon from "@material-ui/icons/Map";
import GGMap from "../../Components/GGMap/GGMap";
import { useSelector, useDispatch } from "react-redux";
import { addPopupLatLng } from "../../Actions/RoomDataAction";
import roomInfo from "./roomInfo";
import MoodIcon from "@material-ui/icons/Mood";
import { useLocation } from "react-router-dom";
import MediaExCard from "../../Components/Experience/MediaExCard";
import { DatePicker } from "@material-ui/pickers";
import ListExp from "../../Components/Experience/ListExp";
const libraries = ["places"];

export default function RoomPage() {
  const useStyles = makeStyles((theme) => ({
    body: {
      maxWidth: "1920px",
      margin: "0 auto",
      backgroundColor: "white",
      width: "100%",
    },
    SDAppBarDiv: {
      zIndex: 100,
      position: "fixed",
      width: "100%",
      top: 0,
      left: "auto",
      right: "auto",
      color: "white",
      maxWidth: "1920px",
      margin: "0 auto",
      [theme.breakpoints.down("xs")]: { display: "none" },
    },
    topDiv: { [theme.breakpoints.up("sm")]: { height: 50 } },
    CheckRoomAppBarDiv: {
      [theme.breakpoints.down("xs")]: {
        zIndex: 10000000000,
        position: "fixed",
        width: "100%",
        bottom: 0,
        left: 0,
        maxWidth: "1920px",
        backgroundColor: "white",
      },
    },
    title: {
      fontSize: 40,
    },
    quickRate: {
      margin: "10px 0",
      textAlign: "center",
    },
    starIcon: { fontSize: 25, color: "#fd3a69" },
    rate: {
      display: "inline",
      marginLeft: 10,
    },
    mainPic: {
      height: 408,
      width: "100%",
      borderRadius: "5% 0 0 5%",
    },

    pic1: {
      height: 200,
      width: "100%",
    },
    pic2: {
      height: 200,

      width: "100%",
      borderRadius: "0 5% 0 0",
    },
    pic3: {
      height: 200,

      width: "100%",
      borderRadius: "0 0 5%  0",
    },
    gridList: {
      flexWrap: "nowrap",
      // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
      transform: "translateZ(0)",
    },
    main: {
      marginTop: 30,
      position: "relative",
      padding: "6% 12% 0 12%",
    },
    leftPart: {
      paddingRight: 30,
      [theme.breakpoints.down("xs")]: { padding: 0 },
    },
    segment: {
      color: "#212121",
      fontSize: 30,
      fontWeight: "bold",
      margin: " 0 0  3% 0",
    },
    line: {
      margin: "6% 0 6% 0",
      borderBottom: "1px solid #968c83",
      width: "100%",
    },
    icon: {
      color: "#212121",
    },
    title: {
      color: "#212121",
      fontWeight: "bold",
      fontSize: 20,
    },
    content: {
      color: "#373a40",
    },
    parentInfoTableDiv: {
      padding: "10px 0",
      width: "100%",
      position: "relative",
    },
    InfoTableDiv: {
      position: "-webkit-sticky",
      position: "sticky",
      top: 170,
      [theme.breakpoints.down("sm")]: { top: 90 },

      width: "100%",
    },
    RateDiv: {
      padding: "0 12%",
      marginTop: 30,
    },
    rateCrit: {
      marginTop: 15,
      padding: "0 50px 0 0",
      [theme.breakpoints.down("xs")]: { padding: "15px 0 15px 0" },
    },
    rateLine: {
      width: "70%",
      borderBottom: "4px solid #222831",
      marginRight: 15,
      borderRadius: 50,
    },

    map: {
      padding: "0 12%",
      marginBottom: "6%",
    },
    roomCheck: {
      boxShadow: "rgb(0 0 0 / 14%) 0px 5px 20px 0px",
      padding: "2% 6%",
      border: "1px solid rgb(0 0 0 / 14%)  ",
      [theme.breakpoints.up("sm")]: { borderRadius: 10 },
    },
    priceRate: {
      fontWeight: "bold",
      fontSize: 25,
      [theme.breakpoints.down("xs")]: { fontSize: 15 },
    },
    BottomPartDiv: {
      position: "relative",
      padding: " 30px 12%",
      backgroundColor: "#f6f5f1",
      borderWidth: "1px 0 0 0",
      borderColor: "#bbbfca",
      borderStyle: "solid",
      zIndex: 1000,
    },
    outBorder: {
      marginTop: 20,
      borderRadius: 10,
      border: "1px solid #707070",
      height: 100,
      fontSize: 13,
      color: "#373a40",
      [theme.breakpoints.down("xs")]: { display: "none" },
    },
    inBorderTop: {
      borderTop: "1px solid #707070",
      padding: "3%",
    },
    inBorderRight: {
      borderRight: "1px solid #707070",
      padding: "3% 3% 0 3%",
    },
    checkOut: { padding: "3% 3% 0 3%" },
    checkRoomStatus: {
      margin: "30px auto",
      border: "1px solid #fd3a69",
      borderRadius: 10,
      textAlign: "center",
      fontSize: 20,
      [theme.breakpoints.down("sm")]: { fontSize: 15 },
      [theme.breakpoints.down("xs")]: { fontSize: 20, margin: 0 },
      padding: "7px 0",
      backgroundColor: "#fd3a69",
      color: "white",
    },
    reportRoom: {
      textAlign: "center",
      margin: "30px auto",
      [theme.breakpoints.down("xs")]: { display: "none" },
    },
    rateCheckRoom: {
      [theme.breakpoints.up("sm")]: { justifyContent: "flex-end" },
    },
  }));
  const checkDate = useSelector((state) => state.checkDate);

  const classes = useStyles();
  const mapRef = useRef();
  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);
  const mapContainerStyle = {
    width: "100%",
    height: "87vh",
  };
  const center = {
    lat: 10.823099,
    lng: 106.629662,
  };
  const location = useLocation();
  const [selected, setSelected] = useState(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });
  const roomData = useSelector((state) => state.roomData.roomList);
  const roomCode = roomData[location.pathname.substring(7)];
  const roomPicArray = [
    { mainPic: roomCode.mainPic },
    { mainPic: roomCode.subPic1 },
    { mainPic: roomCode.subPic2 },
    { mainPic: roomCode.subPic3 },
    { mainPic: roomCode.subPic4 },
  ];
  const subPicSrc =
    "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg";
  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading Maps";

  return (
    <div className={classes.body}>
      <div className={classes.SDAppBarDiv}>
        <ScrollDownAppBar
          pageStyle={{
            padding: "0 12%",
            backgroundColor: "white",
            boxShadow: "0px -5px 20px 0px #888888",
          }}
          logoColor={{ color: "#fd3a69" }}
          linkColor={{ color: "#393e46" }}
          color={"#393e46"}
          panto={true}
          scrollDownAppBar={true}
        />
      </div>
      <div className={classes.main}>
        <div className={classes.topDiv} />
        <Typography className={classes.segment}>Nice Double Room</Typography>
        <Grid alignItems="center" container className={classes.quickRate}>
          <StarIcon className={classes.starIcon} />
          {roomCode.rate} (46).
          <MoodIcon
            style={{ fontSize: 18, color: "#fd3a69", marginLeft: 10 }}
          />
          <Typography>Chủ nhà siêu cấp.</Typography>
          <Typography className={classes.rate}>{roomCode.cityName}</Typography>
        </Grid>
        <Hidden xsDown>
          <Grid container spacing={1} xs={12} className={classes.roomPics}>
            <Grid container justify="center" alignItems="stretch" item xs={6}>
              <img className={classes.mainPic} src={roomCode.mainPic} />
            </Grid>
            <Grid container spacing={1} item xs={6}>
              <Grid spacing={1} direction="column" container item xs={6}>
                <Grid container justify="flex-end" item>
                  <img className={classes.pic1} src={subPicSrc} />
                </Grid>
                <Grid container justify="flex-end" item>
                  <img className={classes.pic1} src={subPicSrc} />
                </Grid>
              </Grid>
              <Grid spacing={1} direction="column" container item xs={6}>
                <Grid container justify="flex-end" item>
                  <img className={classes.pic2} src={subPicSrc} />
                </Grid>
                <Grid container justify="flex-end" item>
                  <img className={classes.pic3} src={subPicSrc} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Hidden>
        <Hidden smUp>
          <GridList className={classes.gridList} cols={2.5}>
            {roomPicArray.map((tile, index) => {
              return <MediaExCard key={index} imgURL={tile.mainPic} />;
            })}
          </GridList>
        </Hidden>
      </div>
      <div className={classes.main}>
        <Grid container xs={12}>
          <Grid item container xs={12} sm={8} className={classes.leftPart}>
            <div style={{ width: "100%" }}>
              <Typography className={classes.segment}>
                Phòng tại khách sạn boutique
              </Typography>
              <Typography style={{ color: "#373a40" }}>
                2 khách. phòng studio. 1 giường
              </Typography>
              <div className={classes.line} />
              {roomInfo[0].map((item, index) => {
                return (
                  <AboutRoom
                    key={index}
                    icon={item.icon}
                    title={item.title}
                    content={item.content}
                  />
                );
              })}
              <div className={classes.line} />
              <Typography className={classes.segment}>
                Liên hệ với chủ nhà
              </Typography>
              <div className={classes.line} />
              <div>
                <Grid xs={12} container>
                  {roomInfo[1].map((item, index) => {
                    return (
                      <Convenience
                        key={index}
                        icon={item.icon}
                        title={item.title}
                      />
                    );
                  })}
                </Grid>
              </div>
              <Button style={{ margin: "30px 0 0 0" }} variant="outlined">
                Hiển thị tất cả tiện nghi
              </Button>
            </div>
          </Grid>
          <Grid
            item
            container
            xs={12}
            className={classes.CheckRoomAppBarDiv}
            sm={4}
            justify="flex-end"
          >
            <div className={classes.parentInfoTableDiv}>
              <div className={classes.InfoTableDiv}>
                <InfoTable />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className={classes.RateDiv}>
        <div className={classes.line} />
        <StarIcon className={classes.starIcon} />
        <Typography className={classes.priceRate}>
          {roomCode.rate} (46 đánh giá)
        </Typography>
        <Grid container xs={12}>
          {roomInfo[2].map((crit, index) => {
            return <Rate key={index} crit={crit.crit} rate={crit.rate} />;
          })}
        </Grid>
        <Grid container xs={12} style={{ marginTop: "2%" }}>
          {roomInfo[3].map((item, index) => {
            return (
              <Comment
                key={index}
                name={item.name}
                date={item.date}
                comment={item.comment}
              />
            );
          })}
        </Grid>
        <div className={classes.line} />
      </div>
      <div className={classes.map}>
        <Typography className={classes.segment}>Vị trí</Typography>
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          zoom={14}
          center={{ lat: roomCode.lat, lng: roomCode.lng }}
          onLoad={onMapLoad}
        >
          <Marker
            position={{ lat: roomCode.lat, lng: roomCode.lng }}
            onClick={() => {
              setSelected(true);
            }}
          />
          {selected ? (
            <InfoWindow
              position={{ lat: roomCode.lat, lng: roomCode.lng }}
              onCloseClick={() => {
                setSelected(null);
              }}
            >
              <div>
                <PopUpCard
                  key={roomCode.key}
                  mainPic={roomCode.mainPic}
                  cityName={roomCode.cityName}
                  title={roomCode.title}
                  rate={roomCode.rate}
                  price={roomCode.price}
                />
              </div>
            </InfoWindow>
          ) : null}
        </GoogleMap>
      </div>

      <div className={classes.BottomPartDiv}>
        <BottomPart />
      </div>
    </div>
  );

  function AboutRoom(props) {
    return (
      <>
        <Grid container xs={12} style={{ marginTop: 15 }}>
          <Hidden xsDown>
            {" "}
            <Grid item xs={2} md={1}>
              <div className={classes.icon}>{props.icon}</div>
            </Grid>
          </Hidden>
          <Grid item xs={10} md={11} condition="column">
            <Grid item xs={12}>
              <Typography className={classes.title}>{props.title}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.content}>
                {props.content}
              </Typography>
            </Grid>
          </Grid>
          <Hidden smUp>
            <Grid container justify="flex-end" item xs={2}>
              <div className={classes.icon}>{props.icon}</div>
            </Grid>
          </Hidden>
        </Grid>
      </>
    );
  }
  function Convenience(props) {
    return (
      <Grid
        container
        xs={12}
        sm={6}
        style={{ marginTop: 15 }}
        className={classes.convenience}
      >
        <Hidden xsDown>
          <Grid item sm={2}>
            <div className={classes.icon}>{props.icon}</div>
          </Grid>
        </Hidden>
        <Grid item xs={9} className={classes.content}>
          {props.title}
        </Grid>
        <Hidden smUp>
          <Grid container justify="flex-end" item xs={3}>
            <div className={classes.icon}>{props.icon}</div>
          </Grid>
        </Hidden>
      </Grid>
    );
  }
  function Rate(props) {
    return (
      <Grid container xs={12} sm={6} className={classes.rateCrit}>
        <Grid item xs={6} lg={4}>
          <Typography className={classes.content}>{props.crit}</Typography>
        </Grid>
        <Grid
          container
          alignItems="center"
          justify="flex-end"
          item
          xs={4}
          lg={7}
        >
          <div className={classes.rateLine} />
        </Grid>
        <Grid item container justify="flex-end" xs={2} lg={1}>
          <Typography className={classes.title}>{props.rate}</Typography>
        </Grid>
      </Grid>
    );
  }

  function Comment(props) {
    return (
      <>
        <Grid
          container
          direction="row"
          xs={12}
          sm={6}
          style={{ marginTop: 15 }}
        >
          <Grid item container xs={12}>
            <Grid item xs={3} md={2}>
              <img
                style={{ height: 65, width: 65, borderRadius: 50 }}
                src="https://miro.medium.com/max/13608/1*o8tTGo3vsocTKnCUyz0wHA.jpeg"
              />
            </Grid>
            <Grid item container alignItems="center" xs={9} md={10}>
              <div>
                <Typography className={classes.title}>{props.name}</Typography>
                <Typography style={{ color: "#646464" }}>
                  {props.date}
                </Typography>
              </div>
            </Grid>
          </Grid>
          <Grid item container xs={12}>
            <Typography className={classes.content}>{props.comment}</Typography>
          </Grid>
        </Grid>
      </>
    );
  }

  function InfoTable() {
    return (
      <>
        <Grid container xs={12} className={classes.roomCheck}>
          <Grid item container xs={3} sm={12}>
            <Grid item container alignItems="center" xs={12} sm={6}>
              <span className={classes.priceRate}>{roomCode.price} </span>
              /đêm
            </Grid>
            <Grid
              item
              container
              alignItems="center"
              className={classes.rateCheckRoom}
              xs={12}
              sm={6}
            >
              <StarIcon item className={classes.starIcon} />
              <span className={classes.priceRate}>{roomCode.rate} </span>
              (31)
            </Grid>
          </Grid>
          <Grid sm={12} item container className={classes.outBorder}>
            <Grid item xs={6} className={classes.inBorderRight}>
              <DatePicker
                label="Nhận phòng"
                value={checkDate.checkInDate}
                InputProps={{ disableUnderline: true }}
                format="dd MMM yyyy"
              />
            </Grid>
            <Grid item xs={6} className={classes.checkOut}>
              <DatePicker
                label="Trả phòng"
                value={checkDate.checkOutDate}
                InputProps={{ disableUnderline: true }}
                format="dd MMM yyyy"
              />
            </Grid>

            <Grid container item xs={12} className={classes.inBorderTop}>
              Khách
            </Grid>
          </Grid>

          <Grid item xs={9} sm={12} className={classes.checkRoomStatus}>
            Kiểm tra tình trạng phòng
          </Grid>
        </Grid>
        <Typography className={classes.reportRoom}>
          Báo cáo phòng cho thuê này
        </Typography>
      </>
    );
  }
}
